import { Channel } from '@food/sync';
var authChannel = new Channel('@food/auth');
export { authChannel };
//# sourceMappingURL=channels.js.map